const routes = [
    {
      path: '/recherche',
      name: 'recherche',
      meta: {
        title: 'VLAMS - Saved Lists'
      },
      component: () => import('@/views/Recherche.vue')
    },
    {
      path: '/recherche/:id',
      name: 'recherche-detail',
      component: () => import('@/components/recherche/savedListsV2/RechercheDetail.vue')
    },
    /* {
      path: '/meilisearch',
      name: 'meilisearch',
      component: () => import('@/views/SearchEngine.vue')
    }, */
    {
      path: '/address-recherche',
      name: 'address-recherche',
      meta: {
        title: 'VLAMS - Address Search'
      },
      component: () => import('@/views/AddressSearch.vue')
    },
    {
      path: '/address-pool',
      name: 'address-pool',
      meta: {
        title: 'VLAMS - Address Pool'
      },
      component: () => import('@/components/recherche/rechercheSearch/recherchePool/RecherchePool.vue')
    },
    {
      path: '/ambassadors',
      name: 'ambassadors',
      meta: {
        title: 'VLAMS - Ambassadors'
      },
      component: () => import('@/views/Ambassadors.vue')
    }
  ]

  export default routes
